/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


document.addEventListener('DOMContentLoaded', function() {
  
  // Lettering.js for Closet Edit heading
  if (typeof $ !== 'undefined' && typeof $.fn.lettering !== 'undefined') {
    // TODO: Update section ID after theme publish
    $('#shopify-section-template--16107881889966__50d98717-450c-4aa7-8f66-bd71a3f67897 h3').lettering('words');
  }
  
  // Move popup buttons into specific icon columns
  if (typeof $ !== 'undefined') {
    var columnSection = '#shopify-section-template--20414362124462__89bdd33b-6741-4eec-bb74-9bbbd9930a72';
    
    $(columnSection + ' .index__column:nth-of-type(1)').append(
      $('#shopify-section-template--20414362124462__fcd3ce4d-c2f7-4421-985e-ef834cd0837e .button')
    );
    
    $(columnSection + ' .index__column:nth-of-type(2)').append(
      $('#shopify-section-template--20414362124462__147374ec-0de1-46b3-bdc7-af3e1794a1e1 .button')
    );
    
    $(columnSection + ' .index__column:nth-of-type(3)').append(
      $('#shopify-section-template--20414362124462__506b4e1d-1d9d-4b51-80c0-7e51e1d76d80 .button')
    );
    
    $(columnSection + ' .index__column:nth-of-type(4)').append(
      $('#shopify-section-template--20414362124462__2d6b7add-9095-46c9-aa9a-8ddb4b40ff81 .button')
    );
  }
  
  // Move mega menu titles inline with "Shop Now" links
  document.querySelectorAll('.header__dropdown__image').forEach(function(container) {
    var title = container.querySelector('.hero__title');
    var actions = container.querySelector('.header__dropdown__actions');
    
    if (title && actions) {
      var titleClone = title.cloneNode(true);
      titleClone.classList.add('hero__title--moved');
      actions.insertBefore(titleClone, actions.firstChild);
      title.style.display = 'none';
    }
  });
  
});




  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
